import React from 'react';
import { Link } from 'react-router-dom';
import { IProps } from 'components/PageNavControls/types';

const PageNavControls: React.FC<IProps> = (props) => (
  <div className="page-nav-controls">
    <div className="template-container">
      <div className="template-content">
        {props.onRefresh && (
          <div className="page-nav-controls__refresh-control">
            <button type="button" className="page-nav-controls__refresh-btn" onClick={props.onRefresh} />
          </div>
        )}
        <div className="page-nav-controls__nav-control">
          <span onClick={props.onPrevClick} className={props.prevSN ? 'element__link page-nav-controls__link' : 'page-nav-controls__link__disabled'}>{props.prevBtnText}</span>
          <Link to={props.navBtnLink} className="page-nav-controls__btn">{props.navBtnText}</Link>
          <span onClick={props.onNextClick} className={props.nextSN ? 'element__link page-nav-controls__link' : 'page-nav-controls__link__disabled'}>{props.nextBtnText}</span>
        </div>
      </div>
    </div>
  </div>
);

PageNavControls.defaultProps = {
  prevBtnText: '上一則',
  nextBtnText: '下一則'
};

export default PageNavControls;
